import { log } from 'console';
import apiRequest from './apiRequest';
import toast from 'react-hot-toast';

type CollectionType = {
  handle: string;
  title: string;
  id: string;
};

type FormattedCollectionType = {
  value: string;
  label: string;
};

const getCollectionList = async () => {
  const res = await apiRequest('getAllCollectionList');
  if (res.error) {
    toast.error('Failed to get collection list');
    return;
  }
  const formattedData: FormattedCollectionType[] = res.data.map(
    (collection: CollectionType) => {
      const formatted: FormattedCollectionType = {
        value: collection.id,
        label: collection.title,
      };
      return formatted;
    }
  );

  return formattedData;
};

export default getCollectionList;
